var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.summary.length > 0)?_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.title))])])]),_c('tbody',_vm._l((_vm.summary),function(node){return _c('tr',{key:node.id},[_c('td',{attrs:{"width":"50%"}},[_vm._v(_vm._s(node.name))]),_c('td',{attrs:{"width":"15%"}},[_vm._v(_vm._s(node.quantity))])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }